import { ExportButtonGraphql } from "components/actions/ExportButtonGraphql";
import { useLeadExport } from "lib/hooks/api/leads/useLeadExport";
import { EventDataTypes } from "lib/tracking";
import { convertLeadFiltersToSearchRequest, LeadFilters } from "./utils";

export default function ExportLeadsButton({
  filters,
  totalCount,
  isLoading,
  selectedLeads,
}: {
  filters: LeadFilters;
  totalCount?: number;
  isLoading?: boolean;
  selectedLeads?: string[];
}) {
  const leadExportMutation = useLeadExport();

  const totalResults: number =
    selectedLeads && selectedLeads.length > 0 ? selectedLeads.length : totalCount || 0;

  return (
    <ExportButtonGraphql
      isLoadingTotalResults={isLoading ?? false}
      totalResults={totalResults}
      exportMutation={leadExportMutation}
      exportVariables={{
        filters: convertLeadFiltersToSearchRequest(filters),
        pagination: {
          pageSize: totalResults + 1,
          page: 1,
        },
        selectedLeads: { leadIds: selectedLeads },
      }}
      exportDataType={EventDataTypes.lead}
    />
  );
}
